export  const checkPermissions = (userPermissions, requiredPermissions) => {
    return requiredPermissions?.every(permission => userPermissions?.includes(permission));
  };
  export const permissionsMessage=(t,objet,permissions)=>{ return t("notification:permissions.not_permissions_dynamic",{action: permissions?.map(element => { return t(`dashboard:collaborators.permissions.permissions_list.${objet}.permissions.${element}`)})?.join(', ') })}
  
   